import * as yup from "yup";

export const scheme = yup
  .object({
    levelName: yup.string().required("Level Name is required"),
    // level image is any required
    levelImage: yup.string().required("Level Image is required"),
    xpMinimum: yup.string().required("XP Minimum is required"),
    xpMaksimum: yup.string().required("XP Maximum is required"),
    status: yup.string().required("Status is required"),
  })
  .required();
